import { forwardRef, type ReactNode, type Ref, useLayoutEffect } from 'react'

import { createPortal } from 'react-dom'

import { Wrapper } from './Wrapper'

type Props = {
	hasModal: boolean
	children?: ReactNode
}

export const FixedContainer = forwardRef(({ hasModal, children }: Props, ref?: Ref<HTMLDivElement>) => {
	useLayoutEffect(() => {
		const root = document.getElementById('root')
		if (!root || !hasModal) return

		root.ariaHidden = 'true'

		return () => {
			root.ariaHidden = 'false'
		}
	}, [hasModal])

	return createPortal(
		<Wrapper ref={ref} hasModal={hasModal}>
			{children}
		</Wrapper>,
		document.body,
	)
})
